module.exports = __webpack_public_path__ + "static/media/noPaySVG.596ef5d0.svg";